import { Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ConfirmRemoveDialog } from './ConfirmRemoveDialog';
import { RecipientModal } from '../../../RecipientModal';
export function RecipientActions(props) {
    const { recipient } = props;
    const [renderEditDialog, setRenderEditDialog] = useState(false);
    const [renderRemoveDialog, setRenderRemoveDialog] = useState(false);
    const showEditDialog = () => setRenderEditDialog(true);
    const hideEditDialog = () => setRenderEditDialog(false);
    const showRemoveDialog = () => setRenderRemoveDialog(true);
    const hideRemoveDialog = () => setRenderRemoveDialog(false);
    return (<Fragment>
      {renderEditDialog && <RecipientModal initialValues={recipient} onClose={hideEditDialog}/>}
      {renderRemoveDialog && <ConfirmRemoveDialog recipient={recipient} onClose={hideRemoveDialog}/>}
      <Menu.Root target={<IconButton size="xs" appearance="secondary">
            <Falcon icon="ellipsis-v"/>
          </IconButton>}>
        <Menu.Item onClick={showEditDialog}>
          <Falcon icon="pen"/>
          <Trans comment="Label for editing signing contact">Edit</Trans>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item onClick={showRemoveDialog}>
          <Falcon icon="trash-can"/>
          <Trans comment="Label for removing signing contact">Remove</Trans>
        </Menu.Item>
      </Menu.Root>
    </Fragment>);
}
